export interface USCity {
  city: string
  state: string
  zip: string
}

// Top ~300 US cities by population with representative zip codes
export const US_CITIES: USCity[] = [
  { city: "New York", state: "NY", zip: "10001" },
  { city: "Los Angeles", state: "CA", zip: "90001" },
  { city: "Chicago", state: "IL", zip: "60601" },
  { city: "Houston", state: "TX", zip: "77001" },
  { city: "Phoenix", state: "AZ", zip: "85001" },
  { city: "Philadelphia", state: "PA", zip: "19101" },
  { city: "San Antonio", state: "TX", zip: "78201" },
  { city: "San Diego", state: "CA", zip: "92101" },
  { city: "Dallas", state: "TX", zip: "75201" },
  { city: "San Jose", state: "CA", zip: "95101" },
  { city: "Austin", state: "TX", zip: "73301" },
  { city: "Jacksonville", state: "FL", zip: "32099" },
  { city: "Fort Worth", state: "TX", zip: "76101" },
  { city: "Columbus", state: "OH", zip: "43085" },
  { city: "Charlotte", state: "NC", zip: "28201" },
  { city: "Indianapolis", state: "IN", zip: "46201" },
  { city: "San Francisco", state: "CA", zip: "94102" },
  { city: "Seattle", state: "WA", zip: "98101" },
  { city: "Denver", state: "CO", zip: "80201" },
  { city: "Nashville", state: "TN", zip: "37201" },
  { city: "Oklahoma City", state: "OK", zip: "73101" },
  { city: "El Paso", state: "TX", zip: "79901" },
  { city: "Washington", state: "DC", zip: "20001" },
  { city: "Las Vegas", state: "NV", zip: "89101" },
  { city: "Louisville", state: "KY", zip: "40201" },
  { city: "Memphis", state: "TN", zip: "37501" },
  { city: "Portland", state: "OR", zip: "97201" },
  { city: "Baltimore", state: "MD", zip: "21201" },
  { city: "Milwaukee", state: "WI", zip: "53201" },
  { city: "Albuquerque", state: "NM", zip: "87101" },
  { city: "Tucson", state: "AZ", zip: "85701" },
  { city: "Fresno", state: "CA", zip: "93650" },
  { city: "Sacramento", state: "CA", zip: "94203" },
  { city: "Kansas City", state: "MO", zip: "64101" },
  { city: "Mesa", state: "AZ", zip: "85201" },
  { city: "Atlanta", state: "GA", zip: "30301" },
  { city: "Omaha", state: "NE", zip: "68101" },
  { city: "Colorado Springs", state: "CO", zip: "80901" },
  { city: "Raleigh", state: "NC", zip: "27601" },
  { city: "Long Beach", state: "CA", zip: "90801" },
  { city: "Virginia Beach", state: "VA", zip: "23450" },
  { city: "Minneapolis", state: "MN", zip: "55401" },
  { city: "Tampa", state: "FL", zip: "33601" },
  { city: "New Orleans", state: "LA", zip: "70112" },
  { city: "Arlington", state: "TX", zip: "76001" },
  { city: "Wichita", state: "KS", zip: "67201" },
  { city: "Bakersfield", state: "CA", zip: "93301" },
  { city: "Aurora", state: "CO", zip: "80010" },
  { city: "Anaheim", state: "CA", zip: "92801" },
  { city: "Santa Ana", state: "CA", zip: "92701" },
  { city: "Corpus Christi", state: "TX", zip: "78401" },
  { city: "Riverside", state: "CA", zip: "92501" },
  { city: "St. Louis", state: "MO", zip: "63101" },
  { city: "Lexington", state: "KY", zip: "40502" },
  { city: "Pittsburgh", state: "PA", zip: "15201" },
  { city: "Stockton", state: "CA", zip: "95201" },
  { city: "Anchorage", state: "AK", zip: "99501" },
  { city: "Cincinnati", state: "OH", zip: "45201" },
  { city: "St. Paul", state: "MN", zip: "55101" },
  { city: "Greensboro", state: "NC", zip: "27401" },
  { city: "Toledo", state: "OH", zip: "43601" },
  { city: "Newark", state: "NJ", zip: "07101" },
  { city: "Plano", state: "TX", zip: "75023" },
  { city: "Henderson", state: "NV", zip: "89002" },
  { city: "Orlando", state: "FL", zip: "32801" },
  { city: "Lincoln", state: "NE", zip: "68501" },
  { city: "Jersey City", state: "NJ", zip: "07302" },
  { city: "Chandler", state: "AZ", zip: "85224" },
  { city: "St. Petersburg", state: "FL", zip: "33701" },
  { city: "Laredo", state: "TX", zip: "78040" },
  { city: "Norfolk", state: "VA", zip: "23501" },
  { city: "Madison", state: "WI", zip: "53701" },
  { city: "Durham", state: "NC", zip: "27701" },
  { city: "Lubbock", state: "TX", zip: "79401" },
  { city: "Winston-Salem", state: "NC", zip: "27101" },
  { city: "Garland", state: "TX", zip: "75040" },
  { city: "Glendale", state: "AZ", zip: "85301" },
  { city: "Hialeah", state: "FL", zip: "33010" },
  { city: "Reno", state: "NV", zip: "89501" },
  { city: "Baton Rouge", state: "LA", zip: "70801" },
  { city: "Irvine", state: "CA", zip: "92602" },
  { city: "Chesapeake", state: "VA", zip: "23320" },
  { city: "Irving", state: "TX", zip: "75061" },
  { city: "Scottsdale", state: "AZ", zip: "85251" },
  { city: "North Las Vegas", state: "NV", zip: "89030" },
  { city: "Fremont", state: "CA", zip: "94536" },
  { city: "Gilbert", state: "AZ", zip: "85234" },
  { city: "San Bernardino", state: "CA", zip: "92401" },
  { city: "Birmingham", state: "AL", zip: "35201" },
  { city: "Rochester", state: "NY", zip: "14601" },
  { city: "Richmond", state: "VA", zip: "23218" },
  { city: "Spokane", state: "WA", zip: "99201" },
  { city: "Des Moines", state: "IA", zip: "50301" },
  { city: "Montgomery", state: "AL", zip: "36101" },
  { city: "Modesto", state: "CA", zip: "95351" },
  { city: "Fayetteville", state: "NC", zip: "28301" },
  { city: "Tacoma", state: "WA", zip: "98401" },
  { city: "Shreveport", state: "LA", zip: "71101" },
  { city: "Akron", state: "OH", zip: "44301" },
  { city: "Aurora", state: "IL", zip: "60505" },
  { city: "Yonkers", state: "NY", zip: "10701" },
  { city: "Huntington Beach", state: "CA", zip: "92647" },
  { city: "Little Rock", state: "AR", zip: "72201" },
  { city: "Columbus", state: "GA", zip: "31901" },
  { city: "Amarillo", state: "TX", zip: "79101" },
  { city: "Glendale", state: "CA", zip: "91201" },
  { city: "Grand Rapids", state: "MI", zip: "49501" },
  { city: "Salt Lake City", state: "UT", zip: "84101" },
  { city: "Tallahassee", state: "FL", zip: "32301" },
  { city: "Huntsville", state: "AL", zip: "35801" },
  { city: "Worcester", state: "MA", zip: "01601" },
  { city: "Knoxville", state: "TN", zip: "37901" },
  { city: "Newport News", state: "VA", zip: "23601" },
  { city: "Brownsville", state: "TX", zip: "78520" },
  { city: "Providence", state: "RI", zip: "02901" },
  { city: "Garden Grove", state: "CA", zip: "92840" },
  { city: "Oceanside", state: "CA", zip: "92049" },
  { city: "Chattanooga", state: "TN", zip: "37401" },
  { city: "Fort Lauderdale", state: "FL", zip: "33301" },
  { city: "Rancho Cucamonga", state: "CA", zip: "91701" },
  { city: "Santa Clarita", state: "CA", zip: "91350" },
  { city: "Port Arthur", state: "TX", zip: "77640" },
  { city: "Tempe", state: "AZ", zip: "85281" },
  { city: "Cape Coral", state: "FL", zip: "33904" },
  { city: "Oxnard", state: "CA", zip: "93030" },
  { city: "Eugene", state: "OR", zip: "97401" },
  { city: "Peoria", state: "AZ", zip: "85345" },
  { city: "Salem", state: "OR", zip: "97301" },
  { city: "Cary", state: "NC", zip: "27511" },
  { city: "Corona", state: "CA", zip: "92879" },
  { city: "Springfield", state: "MO", zip: "65801" },
  { city: "Fort Collins", state: "CO", zip: "80521" },
  { city: "Jackson", state: "MS", zip: "39201" },
  { city: "Alexandria", state: "VA", zip: "22301" },
  { city: "Hayward", state: "CA", zip: "94540" },
  { city: "Lancaster", state: "CA", zip: "93534" },
  { city: "Salinas", state: "CA", zip: "93901" },
  { city: "Palmdale", state: "CA", zip: "93550" },
  { city: "Sunnyvale", state: "CA", zip: "94085" },
  { city: "Pomona", state: "CA", zip: "91766" },
  { city: "Escondido", state: "CA", zip: "92025" },
  { city: "Kansas City", state: "KS", zip: "66101" },
  { city: "Rockford", state: "IL", zip: "61101" },
  { city: "Torrance", state: "CA", zip: "90501" },
  { city: "Paterson", state: "NJ", zip: "07501" },
  { city: "Bridgeport", state: "CT", zip: "06601" },
  { city: "McAllen", state: "TX", zip: "78501" },
  { city: "Hollywood", state: "FL", zip: "33019" },
  { city: "Syracuse", state: "NY", zip: "13201" },
  { city: "Mesquite", state: "TX", zip: "75149" },
  { city: "Pasadena", state: "TX", zip: "77501" },
  { city: "Lakewood", state: "CO", zip: "80214" },
  { city: "Macon", state: "GA", zip: "31201" },
  { city: "Savannah", state: "GA", zip: "31401" },
  { city: "Pomona", state: "CA", zip: "91766" },
  { city: "Clarksville", state: "TN", zip: "37040" },
  { city: "Bellevue", state: "WA", zip: "98004" },
  { city: "Hampton", state: "VA", zip: "23669" },
  { city: "Warren", state: "MI", zip: "48088" },
  { city: "West Valley City", state: "UT", zip: "84119" },
  { city: "Columbia", state: "SC", zip: "29201" },
  { city: "Sterling Heights", state: "MI", zip: "48310" },
  { city: "New Haven", state: "CT", zip: "06501" },
  { city: "Waco", state: "TX", zip: "76701" },
  { city: "Thousand Oaks", state: "CA", zip: "91360" },
  { city: "Cedar Rapids", state: "IA", zip: "52401" },
  { city: "Elizabeth", state: "NJ", zip: "07201" },
  { city: "Roseville", state: "CA", zip: "95678" },
  { city: "Denton", state: "TX", zip: "76201" },
  { city: "Visalia", state: "CA", zip: "93277" },
  { city: "Olathe", state: "KS", zip: "66061" },
  { city: "Gainesville", state: "FL", zip: "32601" },
  { city: "Simi Valley", state: "CA", zip: "93065" },
  { city: "Stamford", state: "CT", zip: "06901" },
  { city: "Concord", state: "CA", zip: "94519" },
  { city: "Hartford", state: "CT", zip: "06101" },
  { city: "Surprise", state: "AZ", zip: "85374" },
  { city: "Peoria", state: "IL", zip: "61601" },
  { city: "Lansing", state: "MI", zip: "48901" },
  { city: "Victorville", state: "CA", zip: "92392" },
  { city: "El Monte", state: "CA", zip: "91731" },
  { city: "Murfreesboro", state: "TN", zip: "37130" },
  { city: "Ontario", state: "CA", zip: "91758" },
  { city: "Vancouver", state: "WA", zip: "98660" },
  { city: "Evansville", state: "IN", zip: "47701" },
  { city: "Fullerton", state: "CA", zip: "92831" },
  { city: "Athens", state: "GA", zip: "30601" },
  { city: "Midland", state: "TX", zip: "79701" },
  { city: "Beaumont", state: "TX", zip: "77701" },
  { city: "Killeen", state: "TX", zip: "76540" },
  { city: "West Jordan", state: "UT", zip: "84084" },
  { city: "Downey", state: "CA", zip: "90241" },
  { city: "Costa Mesa", state: "CA", zip: "92626" },
  { city: "Elgin", state: "IL", zip: "60120" },
  { city: "Peoria", state: "AZ", zip: "85345" },
  { city: "Manchester", state: "NH", zip: "03101" },
  { city: "Clearwater", state: "FL", zip: "33755" },
  { city: "Provo", state: "UT", zip: "84601" },
  { city: "Inglewood", state: "CA", zip: "90301" },
  { city: "Waterbury", state: "CT", zip: "06701" },
  { city: "Springfield", state: "MA", zip: "01101" },
  { city: "Santa Rosa", state: "CA", zip: "95401" },
  { city: "Rancho Cucamonga", state: "CA", zip: "91701" },
  { city: "Fort Wayne", state: "IN", zip: "46801" },
  { city: "Pembroke Pines", state: "FL", zip: "33082" },
  { city: "Flint", state: "MI", zip: "48501" },
  { city: "Ann Arbor", state: "MI", zip: "48103" },
  { city: "West Palm Beach", state: "FL", zip: "33401" },
  { city: "Murrieta", state: "CA", zip: "92562" },
  { city: "Erie", state: "PA", zip: "16501" },
  { city: "Palm Bay", state: "FL", zip: "32905" },
  { city: "Clovis", state: "CA", zip: "93611" },
  { city: "Peoria", state: "IL", zip: "61601" },
  { city: "Athens-Clarke County", state: "GA", zip: "30601" },
  { city: "Antioch", state: "CA", zip: "94509" },
  { city: "Santa Clara", state: "CA", zip: "95050" },
  { city: "Arvada", state: "CO", zip: "80001" },
  { city: "Independence", state: "MO", zip: "64050" },
  { city: "Spokane Valley", state: "WA", zip: "99206" },
  { city: "Hayward", state: "CA", zip: "94541" },
  { city: "Ontario", state: "CA", zip: "91761" },
  { city: "Glendale", state: "CA", zip: "91206" },
  { city: "Chattanooga", state: "TN", zip: "37421" },
  { city: "Columbus", state: "IN", zip: "47201" },
  { city: "Topeka", state: "KS", zip: "66601" },
  { city: "Tempe", state: "AZ", zip: "85282" },
  { city: "Pomona", state: "CA", zip: "91768" },
  { city: "Pasadena", state: "CA", zip: "91101" },
  { city: "Lakewood", state: "CA", zip: "90712" },
  { city: "Joliet", state: "IL", zip: "60431" },
  { city: "Rockford", state: "IL", zip: "61102" },
  { city: "Naperville", state: "IL", zip: "60540" },
  { city: "Paterson", state: "NJ", zip: "07502" },
  { city: "Moreno Valley", state: "CA", zip: "92551" },
  { city: "Fayetteville", state: "AR", zip: "72701" },
  { city: "Knoxville", state: "TN", zip: "37902" },
  { city: "Glendale", state: "AZ", zip: "85302" },
  { city: "Worcester", state: "MA", zip: "01602" },
  { city: "Little Rock", state: "AR", zip: "72202" },
  { city: "Oceanside", state: "CA", zip: "92054" },
  { city: "Garden Grove", state: "CA", zip: "92843" },
  { city: "Chattanooga", state: "TN", zip: "37402" },
  { city: "Tallahassee", state: "FL", zip: "32303" },
  { city: "Aurora", state: "IL", zip: "60506" },
  { city: "Colorado Springs", state: "CO", zip: "80903" },
  { city: "Salt Lake City", state: "UT", zip: "84111" },
  { city: "Shreveport", state: "LA", zip: "71103" },
  { city: "Jackson", state: "MS", zip: "39209" },
  { city: "Baton Rouge", state: "LA", zip: "70806" },
  { city: "Huntsville", state: "AL", zip: "35816" },
  { city: "Springfield", state: "IL", zip: "62701" },
  { city: "Overland Park", state: "KS", zip: "66204" },
  { city: "Tempe", state: "AZ", zip: "85283" },
  { city: "Sioux Falls", state: "SD", zip: "57101" },
  { city: "Boise", state: "ID", zip: "83701" },
  { city: "Cape Coral", state: "FL", zip: "33990" },
  { city: "Hampton", state: "VA", zip: "23661" },
  { city: "Eugene", state: "OR", zip: "97402" },
  { city: "Peoria", state: "AZ", zip: "85381" },
  { city: "Salem", state: "OR", zip: "97302" },
  { city: "Fort Collins", state: "CO", zip: "80524" },
  { city: "Waco", state: "TX", zip: "76710" },
  { city: "Gainesville", state: "FL", zip: "32607" },
  { city: "Denton", state: "TX", zip: "76205" },
  { city: "Lansing", state: "MI", zip: "48912" },
  { city: "Evansville", state: "IN", zip: "47708" },
  { city: "Fort Wayne", state: "IN", zip: "46802" },
  { city: "West Palm Beach", state: "FL", zip: "33411" },
  { city: "Ann Arbor", state: "MI", zip: "48104" },
  { city: "Santa Clarita", state: "CA", zip: "91355" },
  { city: "Columbia", state: "MO", zip: "65201" },
  { city: "Providence", state: "RI", zip: "02903" },
  { city: "Savannah", state: "GA", zip: "31419" },
  { city: "Clarksville", state: "TN", zip: "37043" },
  { city: "Bellevue", state: "WA", zip: "98007" },
  { city: "Hartford", state: "CT", zip: "06103" },
  { city: "Bridgeport", state: "CT", zip: "06604" },
  { city: "New Haven", state: "CT", zip: "06511" },
  { city: "Stamford", state: "CT", zip: "06905" },
  { city: "Flint", state: "MI", zip: "48502" },
  { city: "Sterling Heights", state: "MI", zip: "48312" },
  { city: "Warren", state: "MI", zip: "48089" },
  { city: "West Jordan", state: "UT", zip: "84088" },
  { city: "Provo", state: "UT", zip: "84604" },
  { city: "Sioux Falls", state: "SD", zip: "57104" },
  { city: "Boise", state: "ID", zip: "83705" },
  { city: "Overland Park", state: "KS", zip: "66210" },
  { city: "Springfield", state: "IL", zip: "62702" },
  { city: "Manchester", state: "NH", zip: "03102" },
  { city: "Clearwater", state: "FL", zip: "33759" },
  { city: "Pembroke Pines", state: "FL", zip: "33024" },
  { city: "Murfreesboro", state: "TN", zip: "37129" },
  { city: "Murrieta", state: "CA", zip: "92563" },
  { city: "Palm Bay", state: "FL", zip: "32907" },
  { city: "Clovis", state: "CA", zip: "93612" },
  { city: "Antioch", state: "CA", zip: "94531" },
  { city: "Arvada", state: "CO", zip: "80003" },
  { city: "Naperville", state: "IL", zip: "60563" },
  { city: "Moreno Valley", state: "CA", zip: "92553" },
  { city: "Fayetteville", state: "AR", zip: "72703" },
  { city: "Columbia", state: "MO", zip: "65202" },
  { city: "Midland", state: "TX", zip: "79703" },
  { city: "Beaumont", state: "TX", zip: "77705" },
  { city: "Killeen", state: "TX", zip: "76541" },
  { city: "Topeka", state: "KS", zip: "66604" },
  { city: "Erie", state: "PA", zip: "16505" },
  { city: "Joliet", state: "IL", zip: "60435" },
]

export function searchCities(query: string, limit = 8): USCity[] {
  if (!query || query.length < 1) return []
  const q = query.toLowerCase()
  return US_CITIES.filter(
    (c) =>
      c.city.toLowerCase().startsWith(q) ||
      `${c.city.toLowerCase()}, ${c.state.toLowerCase()}`.startsWith(q) ||
      c.zip.startsWith(q) ||
      c.city.toLowerCase().includes(q)
  )
    .sort((a, b) => {
      // Prioritize starts-with matches
      const aStarts = a.city.toLowerCase().startsWith(q)
      const bStarts = b.city.toLowerCase().startsWith(q)
      if (aStarts && !bStarts) return -1
      if (!aStarts && bStarts) return 1
      return a.city.localeCompare(b.city)
    })
    .slice(0, limit)
}

export function formatCity(c: USCity): string {
  return `${c.city}, ${c.state}`
}
